import { FramedImage } from "@/components/FramedImage";
import { HERO_IMAGE } from "@/data/photos";

const Hero = () => (
  <section data-testid="hero-section" className="px-6 pt-28 md:px-12 md:pt-40">
    <div className="md:grid md:grid-cols-12">
      <div className="md:col-span-8 md:col-start-3">
        <FramedImage
          src={HERO_IMAGE.src}
          alt={HERO_IMAGE.alt}
          natural
          ratio={HERO_IMAGE.ratio}
          className="w-full"
        />
      </div>
    </div>
  </section>
);

export default Hero;
